module.exports = __webpack_public_path__ + "media/ช่วยตัวเองหน่อยสิ่คะ.190e144f.mp3";